let ctx = null;
let nodes = null;

const ensureCtx = () => {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const makeNoiseBuffer = (c) => {
  const len = c.sampleRate * 2;
  const buf = c.createBuffer(1, len, c.sampleRate);
  const data = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i++) {
    const white = Math.random() * 2 - 1;
    last = (last + 0.02 * white) / 1.02;
    data[i] = last * 3.2;
  }
  return buf;
};

export const startSession = ({ freq = 432, binaural = 4, tone = 0.1, noise = 0.04 } = {}) => {
  const c = ensureCtx();
  stopSession(0.4);

  const now = c.currentTime;
  const master = c.createGain();
  master.gain.setValueAtTime(0.0001, now);
  master.gain.exponentialRampToValueAtTime(1, now + 2.5);
  master.connect(c.destination);

  const oscL = c.createOscillator();
  oscL.type = "sine";
  oscL.frequency.value = freq;
  const oscR = c.createOscillator();
  oscR.type = "sine";
  oscR.frequency.value = freq + binaural;
  const panL = c.createStereoPanner();
  panL.pan.value = -0.6;
  const panR = c.createStereoPanner();
  panR.pan.value = 0.6;
  const toneGain = c.createGain();
  toneGain.gain.value = tone;
  oscL.connect(panL);
  oscR.connect(panR);
  panL.connect(toneGain);
  panR.connect(toneGain);
  toneGain.connect(master);

  const sub = c.createOscillator();
  sub.type = "triangle";
  sub.frequency.value = freq / 2;
  const subGain = c.createGain();
  subGain.gain.value = tone * 0.45;
  sub.connect(subGain);
  subGain.connect(master);

  const lfo = c.createOscillator();
  lfo.frequency.value = 0.08;
  const lfoGain = c.createGain();
  lfoGain.gain.value = tone * 0.35;
  lfo.connect(lfoGain);
  lfoGain.connect(toneGain.gain);

  const noiseSrc = c.createBufferSource();
  noiseSrc.buffer = makeNoiseBuffer(c);
  noiseSrc.loop = true;
  const filter = c.createBiquadFilter();
  filter.type = "bandpass";
  filter.frequency.value = 750;
  filter.Q.value = 0.6;
  const noiseGain = c.createGain();
  noiseGain.gain.value = noise;
  noiseSrc.connect(filter);
  filter.connect(noiseGain);
  noiseGain.connect(master);

  const sources = [oscL, oscR, sub, lfo, noiseSrc];
  sources.forEach((s) => s.start());
  nodes = { master, sources };
};

export const stopSession = (fade = 2) => {
  if (!ctx || !nodes) return;
  const now = ctx.currentTime;
  const { master, sources } = nodes;
  nodes = null;
  master.gain.cancelScheduledValues(now);
  master.gain.setValueAtTime(Math.max(master.gain.value, 0.0001), now);
  master.gain.exponentialRampToValueAtTime(0.0001, now + fade);
  sources.forEach((s) => {
    try {
      s.stop(now + fade + 0.1);
    } catch (e) {
      /* already stopped */
    }
  });
};
